"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadGoogleSdk = exports.loginWithGoogleSDK = void 0;
var _waitForVar = _interopRequireDefault(require("../../utils/waitForVar"));
const loginWithGoogleSDK = async () => {
  const loadGoogleVar = await (0, _waitForVar.default)("google");
  if (loadGoogleVar == null) {
    return Promise.reject(new Error("google script was not loaded."));
  }
  return new Promise((resolve, reject) => {
    const tokenClientConfig = {
      // eslint-disable-next-line babel/camelcase
      client_id: "190201978312-d6ka4ulprck0ootor1m2nnjm36mu0ds8.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
      callback: tokenResponse => {
        if (tokenResponse.error) {
          reject(tokenResponse);
        }
        resolve(tokenResponse);
      },
      error_callback: error => {
        reject(error);
      }
    };
    const tokenClient = google.accounts.oauth2.initTokenClient(tokenClientConfig);
    try {
      tokenClient.requestAccessToken();
    } catch (e) {
      reject(e);
    }
  });
};
exports.loginWithGoogleSDK = loginWithGoogleSDK;
const loadGoogleSdk = () => {
  if (typeof window !== "undefined" && typeof window.google === "undefined") {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
};
exports.loadGoogleSdk = loadGoogleSdk;